import { Children, Fragment, cloneElement } from "react"

const TableRow = ({
  row,
  labels,
  isMobile,
  fieldToHeader,
  type,
  columnsPerFieldMap,
  rowClassName,
  onClickHandler,
  className,
  onMouseDown,
  children,
}) => (
  <div
    className={`rounded mb-2 ${
      Children.count(children) !== 0
        ? "d-flex justify-content-between align-items-stretch gap-1 gap-xl-4"
        : ""
    } table-row ${className || ""}`}
  >
    <div
      className={`p-3 ${
        isMobile ? "" : "d-flex"
      } justify-content-around align-items-center custom-row ${
        Children.count(children) !== 0 ? `${rowClassName}` : ``
      } 
       
       ${isMobile ? "mobile" : "desktop"}
      `}
      onClick={onClickHandler}
      onMouseDown={onMouseDown}
    >
      {labels.map((key, idx) => {
        if (key === "id") return null

        const value = row[key]

        const renderValue = () => {
          if (Array.isArray(value) && value.length > 0 && typeof value[0] !== "object") {
            return value.map((entry, i) => {

              return (
                <span key={i} className="me-2">{entry}</span>
              )
              
            })
          } else if (Array.isArray(value) && value.length > 0 && typeof value[0] === "object") {
            return value.map((entry, i) => {
              const lang = entry.lang || ""
              const text = entry.string || entry.multiline || entry.uri || ""

              return (
                <div key={i}>
                  <span className="fw-bold">{text}</span> 
                  {lang.length !== 0 && <span className="ms-2">({lang})</span>}
                </div>
              )

            })
          }

          // Primitive values
          if (value !== null && value !== undefined && typeof value !== "object") {
            return value
          }

          return null
        }

        return (
          <Fragment key={"row-col-" + idx}>
            {isMobile ? (
              <div className="row">
                <div className="col table-header">
                  {fieldToHeader(key) ? fieldToHeader(key) + ":" : ""}
                </div>
                <div className="col body">{renderValue()}</div>
              </div>
            ) : (
              <div className={`px-2 ${columnsPerFieldMap[key]}`}>
                <div className="text-lg-start text-break body">{renderValue()}</div>
              </div>
            )}
          </Fragment>
        )
      })}
      {isMobile &&
        Children.map(
          children,
          (child) =>
            child &&
            cloneElement(child, {
              onClick: (e) => {
                e.stopPropagation();
              },
            })
        )}
    </div>
    {!isMobile && children}
  </div>
);

export default TableRow;
